import multiOrganisationRouteConfig from './multi-organisation.routes';
import { MultiOrganisationComponent } from './multi-organisation.component';
import { MultiOrganisationService } from './services/multi-organisation.service';

export default angular
  .module('sfMobile.multi-organisation', [])
  .config(multiOrganisationRouteConfig)
  .component('sfMultiOrganisation', MultiOrganisationComponent)
  .service('multiOrganisationService', MultiOrganisationService).name;
